@if (loaded$ | async) {
  <div class="raffle-draw-widget">
    <div class="draw-rows-container">
      @for (row of drawRows; track $index) {
        <div class="draw-row">
          @if (raffleDrawWidget.show_prize_numbers && raffleDrawWidget.enable_bulk_raffle_draw) {
            <div class="prize-header" [style.background-color]="backgroundColor">
              <span class="prize-text" [style.color]="digitColor">
                <span> {{ 'PRESENTER.RAFFLE_DRAW_WIDGET.PRIZE' | translate }} </span><span> {{ $index + 1 }}</span>
              </span>
            </div>
          }
          <div class="digits">
            @for (digitColumn of row.digitColumns; track $index) {
              <div class="digit-square" [style.background-color]="backgroundColor">
                <div class="digit-window">
                  <div
                    class="digit-reel"
                    [class.animating]="row.isAnimating"
                    [ngStyle]="getColumnStyles(digitColumn, row.isAnimating)"
                  >
                    @for (digit of digitColumn.digits; track $index) {
                      <div class="digit" [style.color]="digitColor" [style.font-size.cqw]="digitFontSizeCqw">
                        {{ digit }}
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
  @if (isLaunchMode() || (!inPreviewMode && !isTemplateMode)) {
    <gb-presenter-widget-raffle-item-label
      (click)="raffleDrawWidget.raffle_item ?? openRaffleItemWarning.emit()"
      [raffleItemName]="raffleItemName()"
      [isLaunchMode]="isLaunchMode()"
    ></gb-presenter-widget-raffle-item-label>
  }
} @else {
  <gb-skeleton-loader
    [rows]="1"
    [columns]="6"
    direction="grid"
    borderRadius="0.9cqw"
    [gap]="0.7"
    gapUnit="cqw"
  ></gb-skeleton-loader>
}
